// extracted by mini-css-extract-plugin
module.exports = {"navTitle":"RelationPage_navTitle__2pHe-"};